import React from 'react'
import { RiVipCrownFill } from 'react-icons/ri'
import { GrClose } from 'react-icons/gr'
import { AiOutlineCheck } from 'react-icons/ai'

import { Button, Table } from 'components/ui'
import { useSelector } from 'react-redux'
import THead from 'components/ui/Table/THead'
import Tr from 'components/ui/Table/Tr'
import Th from 'components/ui/Table/Th'
import TBody from 'components/ui/Table/TBody'
import Td from 'components/ui/Table/Td'

const BillingPackages = React.memo(
    ({ packages, selectedPackage, setSelectedPackage, editMode }) => {
        const { premiumTitlesCount, standardTitlesCount } = useSelector(
            (state) => state.checkout.titles
        )
        return (
            <div>
                <h5>Select Plan</h5>
                <div className="my-4  border bg-white">
                    <div>
                        <Table className="border  text-black">
                            <THead>
                                <Tr>
                                    <Th className="border">
                                        <span className="text-black">
                                            Title Tier
                                        </span>
                                    </Th>
                                    <Th className="border">
                                        <span className="text-black">
                                            Basic
                                        </span>
                                    </Th>
                                    <Th className="border">
                                        <span className="text-black">Plus</span>
                                    </Th>
                                    <Th className="border">
                                        <span className="text-black">Pro</span>
                                    </Th>
                                    <Th className="border">
                                        <span className="text-black">
                                            Enterprise
                                        </span>
                                    </Th>
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td className="border">Super Premium</Td>
                                    <Td colSpan={4} className="text-center">
                                        <p className="text-lg">
                                            Custom Pricing
                                        </p>
                                        <p>
                                            Get in touch with our sales team
                                            <a
                                                href="mailto:sales@disco.info"
                                                className="text-secondary underline pl-1"
                                            >
                                                sales@disco.info
                                            </a>
                                        </p>
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td className="border">
                                        Premium (paywalled)
                                    </Td>
                                    {packages.map((one, index) => (
                                        <Td className="border">
                                            {one.premium_num}
                                        </Td>
                                    ))}
                                    <Td
                                        rowSpan={4}
                                        className="text-left border-l"
                                    >
                                        <p className="text-lg">
                                            Do you require?
                                        </p>
                                        <ul className="list-disc ml-3 my-3">
                                            <li>Over 3,000 Titles </li>
                                            <li>Republishing rights</li>
                                            <li>Archival access</li>
                                            <li>
                                                Content enrichment (e.g.
                                                metadata)
                                            </li>
                                            <li>API customization</li>
                                        </ul>
                                        <p className="ml-3">
                                            Get in touch with our sales team
                                            <br />
                                            <a
                                                href="mailto:sales@disco.info"
                                                className="text-secondary underline"
                                            >
                                                sales@disco.info
                                            </a>
                                        </p>
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td className="border">
                                        Standard (free online content)
                                    </Td>
                                    {packages.map((one, index) => (
                                        <Td className="border">
                                            {one.standard_num}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr className="font-semibold">
                                    <Td className="border">Price per month</Td>
                                    {packages.map((one, index) => (
                                        <Td className="border">
                                            ${one.price.toLocaleString()}
                                        </Td>
                                    ))}
                                </Tr>
                                <Tr className="font-semibold">
                                    <Td className="border"></Td>
                                    {packages.map((one, index) => (
                                        <Td className="border">
                                            <Button
                                                size="sm"
                                                variant="solid"
                                                shape="round"
                                                disabled={
                                                    one.id ===
                                                        selectedPackage.id ||
                                                    parseInt(
                                                        premiumTitlesCount
                                                    ) +
                                                        parseInt(
                                                            standardTitlesCount
                                                        ) >=
                                                        parseInt(
                                                            one.premium_num
                                                        ) +
                                                            parseInt(
                                                                one.standard_num
                                                            )
                                                }
                                                onClick={() =>
                                                    setSelectedPackage(one)
                                                }
                                            >
                                                {one.id === selectedPackage.id
                                                    ? 'Current'
                                                    : 'Select'}
                                            </Button>
                                        </Td>
                                    ))}
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </div>
            </div>
        )
    }
)

export default BillingPackages
